// client/src/components/react-public/store-components/Shipping.jsx
import {
  Box,
  Checkbox,
  FormControlLabel,
  Paper,
  Typography,
  useTheme,
} from '@mui/material';
import AddressForm from './AddressForm';
import { tokens } from '../../../theme';

const Shipping = ({
  values,
  touched,
  errors,
  handleChange,
  handleBlur,
  setFieldValue,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const checkoutFieldSx = {
    '& .MuiInputBase-root': {
      color: 'white',
      backgroundColor: 'rgba(255,255,255,0.075)',
      borderRadius: '14px',
    },
    '& .MuiInputBase-input': {
      color: 'white',
    },
    '& .MuiInputLabel-root': {
      color: colors.grey[300],
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: colors.greenAccent[300],
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(255,255,255,0.18)',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: colors.greenAccent[500],
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: colors.greenAccent[400],
    },
    '& .MuiFormHelperText-root': {
      color: colors.redAccent?.[300] || '#ff8a80',
      fontWeight: 600,
    },
  };

  return (
    <Box m="30px auto">
      <Paper
        elevation={0}
        sx={{
          p: { xs: 2.5, md: 3 },
          mb: 3,
          borderRadius: '22px',
          backgroundColor: 'rgba(255,255,255,0.055)',
          border: '1px solid rgba(255,255,255,0.12)',
        }}
      >
        <Typography
          fontSize="20px"
          sx={{
            fontFamily: 'Poppins, sans-serif',
            fontWeight: 900,
            color: colors.greenAccent[300],
            mb: 2,
          }}
        >
          Billing Information
        </Typography>

        <AddressForm
          type="billingAddress"
          values={values.billingAddress}
          touched={touched}
          errors={errors}
          handleBlur={handleBlur}
          handleChange={handleChange}
          fieldSx={checkoutFieldSx}
        />
      </Paper>

      <Paper
        elevation={0}
        sx={{
          p: { xs: 2.5, md: 3 },
          mb: 3,
          borderRadius: '22px',
          backgroundColor: 'rgba(255,255,255,0.055)',
          border: '1px solid rgba(255,255,255,0.12)',
        }}
      >
        <FormControlLabel
          sx={{
            color: colors.grey[100],
            '& .MuiFormControlLabel-label': {
              fontFamily: 'Poppins, sans-serif',
              fontWeight: 700,
            },
          }}
          control={
            <Checkbox
              checked={Boolean(values.shippingAddress.isSameAddress)}
              onChange={
                async (
                  event
                ) => {
                  const checked =
                    event.target.checked;


                  if (checked) {
                    await setFieldValue(
                      'shippingAddress',
                      {
                        ...values
                          .billingAddress,

                        isSameAddress:
                          true,
                      }
                    );

                    return;
                  }


                  await setFieldValue(
                    'shippingAddress.isSameAddress',
                    false
                  );
                }
              }
              sx={{
                color: colors.grey[300],
                '&.Mui-checked': {
                  color: colors.greenAccent[400],
                },
              }}
            />
          }
          label="Same for Shipping Address"
        />
      </Paper>

      {!values.shippingAddress.isSameAddress && (
        <Paper
          elevation={0}
          sx={{
            p: { xs: 2.5, md: 3 },
            borderRadius: '22px',
            backgroundColor: 'rgba(255,255,255,0.055)',
            border: '1px solid rgba(255,255,255,0.12)',
          }}
        >
          <Typography
            fontSize="20px"
            sx={{
              fontFamily: 'Poppins, sans-serif',
              fontWeight: 900,
              color: colors.greenAccent[300],
              mb: 2,
            }}
          >
            Shipping Information
          </Typography>

          <AddressForm
            type="shippingAddress"
            values={values.shippingAddress}
            touched={touched}
            errors={errors}
            handleBlur={handleBlur}
            handleChange={handleChange}
            fieldSx={checkoutFieldSx}
          />
        </Paper>
      )}
    </Box>
  );
};

export default Shipping;